import axios from '@src/utils/axios'

const module = 'prospect'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}/` + data.id, data)
  },
  'find': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/` + data.id)
  },
  'findProspect': (ctx, data) => axiosInstance.get(`/${module}/summary/` + data.id),
  'findUserProspect': (ctx, data) => axiosInstance.get(`/${module}/user_prospect/` + data.user_id),

  'all': () => axiosInstance.get(`/${module}/all`),
  'uploadAvatar': (ctx, data) => axiosInstance.post(`/${module}/upload_avatar`, data),

  'createSkill': (ctx, data) => axiosInstance.post(`/${module}/create_skill`, data),
  'removeSkill': (ctx, data) => axiosInstance.delete(`/${module}/remove_skill/` + data._id),

  'createTag': (ctx, data) => axiosInstance.post(`/${module}/create_tag`, data),
  'removeTag': (ctx, data) => axiosInstance.delete(`/${module}/remove_tag/` + data._id),

  'createEducation': (ctx, data) => axiosInstance.post(`/${module}/create_education`, data),
  'removeEducation': (ctx, data) => axiosInstance.delete(`/${module}/remove_education/` + data._id),
  'updateEducation': (ctx, data) => axiosInstance.put(`/${module}/update_education/` + data._id, data),

  'createWorkingExperience': (ctx, data) => axiosInstance.post(`/${module}/create_working_experience`, data),
  'removeWorkingExperience': (ctx, data) => axiosInstance.delete(`/${module}/remove_working_experience/` + data._id),
  'updateWorkingExperience': (ctx, data) => axiosInstance.put(`/${module}/update_working_experience/` + data._id, data),

  'uploadAttachment' : (ctx, data) => axiosInstance.post(`/${module}/upload_attachment`, data),
  'downloadAttachment' : (ctx, data) => axiosInstance.get(`/${module}/download_attachment`, {params:data}),
  'deleteAttachment' : (ctx, data) => axiosInstance.delete(`/${module}/delete_attachment/` + data.id),

  'finalize': (ctx, data) => axiosInstance.post(`/${module}/finalize`, data),

  'getAcknowledgement': (ctx, data) => axiosInstance.get(`/${module}/acknowledge`, {params:data}),
  'acknowledge' : (ctx, data) => axiosInstance.post(`/${module}/acknowledge`, data),
  'declineAcknowledge' : (ctx, data) => axiosInstance.post(`/${module}/decline_acknowledge`, data),

  'approve' : (ctx, data) => axiosInstance.post(`/${module}/approve`, data),  

}